module.exports = __webpack_public_path__ + "static/img/airoad_icon.0fd0bb95.png";